import { useEffect, useState } from 'react'
import { api, auth } from '../lib/api.js'

const EMPTY = { available: false, reason: 'loading' }

export default function OperatorStats({ agentId }) {
  const [stats, setStats] = useState(EMPTY)
  const isAdmin = auth.isAdmin

  useEffect(() => {
    let alive = true
    setStats(EMPTY)
    const load = () => api.getCwtOperatorStats(isAdmin ? undefined : agentId)
      .then(value => alive && setStats(value || EMPTY))
      .catch(() => alive && setStats({ available: false, reason: 'error' }))
    load()
    const timer = setInterval(load, 30000)
    return () => { alive = false; clearInterval(timer) }
  }, [agentId, isAdmin])

  const rate = stats.available && stats.successRate != null
    ? `${(stats.successRate * 100).toFixed(2).replace(/\.00$/, '')}%`
    : '—'
  const value = stats.available ? stats.orders : '—'
  const today = stats.available ? stats.today : null
  // 车网通的「收款数量」= 成交/付款量（Gavin 2026-10-12：有的运营加微信成交、客户没扫码进线，
  // 拿我们自己的记录去数必然少，所以付款量直接用车网通口径）
  const paid = stats.available ? (stats.paid ?? stats.successes) : '—'
  const todayPaid = today ? (today.paid ?? today.successes) : '—'
  const todayRate = today && today.successRate != null
    ? `${(today.successRate * 100).toFixed(2).replace(/\.00$/, '')}%`
    : '—'
  const todayValue = today ? today.orders : '—'
  return (
    // 「本日」在上、「本月」在下（2026-10-12 Gavin 要求互换）；文字改成圆圈图标：
    // ☀️ = 日、🌙 = 月，配色跟界面统一（沿用 --line/--hover，深色模式自动跟随）。
    // 文字没了，所以保留 title + aria-label，鼠标悬停和读屏都还知道是哪一行。
    <div className="operator-stats" aria-label="本日及本月实况" title={isAdmin ? '车网通运营统计：本页合计（117组，第1页，100条/页）' : '车网通运营统计：本人'}>
      <div className="operator-stats-line operator-stats-today">
        <span className="operator-stats-icon" role="img" aria-label="本日实况" title="本日实况（☀️）">☀️</span>
        <span>接单：<b>{todayValue}</b></span>
        <span>付款：<b>{todayPaid}</b></span>
        <span>成功率：<b>{todayRate}</b></span>
      </div>
      <div className="operator-stats-line">
        <span className="operator-stats-icon" role="img" aria-label="本月实况" title="本月实况（🌙）">🌙</span>
        <span>接单：<b>{value}</b></span>
        <span>付款：<b>{paid}</b></span>
        <span>成功率：<b>{rate}</b></span>
      </div>
    </div>
  )
}
